export const FileDocIcon: React.FC<{ type: keyof typeof BADGE_COLORS }> = ({
  type,
}) => (
  <svg width="46" height="56" viewBox="0 0 46 56" fill="none">
    <path
      d="M3 2h26l13 12v40H3V2z"
      fill="#F9FAFB"
      stroke="#E5E7EB"
      strokeWidth="1"
    />
    <path d="M29 2l13 12H29V2z" fill="#E5E7EB" />
    <rect
      x="3"
      y="34"
      width="40"
      height="20"
      rx="0"
      fill={BADGE_COLORS[type]}
    />
    <text
      x="23"
      y="48"
      textAnchor="middle"
      fill="white"
      fontSize="8.5"
      fontWeight="800"
      fontFamily="system-ui, sans-serif"
      letterSpacing="0.8"
    >
      {type.toUpperCase()}
    </text>
  </svg>
);

// ─── File icon SVG ─────────────────────────────────────────────────────────

const BADGE_COLORS = {
  pdf: "#EF4444",
  ppt: "#F97316",
  doc: "#3B82F6",
} as const;
